var fireInsuranceSearch = function (property_type, structure_materials, use_2800,  building_cost, furniture_price, complex_furniture_price, unit_count, area_size, complex_area_size, fire_build_year_input,fire_province_select, fire_city_select) {

    function showFieldError($field, message) {
        var $target = $field;
        if ($field && $field.length) {
            if ($field.hasClass('select2-hidden-accessible')) {
                $target = $field.next('.select2');
            } else if ($field.next('.select2').length) {
                $target = $field.next('.select2');
            } else if ($field.next().length && !$field.is('input[type="text"], input[type="tel"], textarea')) {
                $target = $field.next();
            }
            try {
                $target.animateCss('shake');
            } catch (e) {}
            $target.addClass('fire-field-error');
            setTimeout(function () {
                $target.removeClass('fire-field-error');
            }, 2500);
        }
        if (typeof Swal !== 'undefined') {
            Swal.fire({
                icon: 'warning',
                title: 'توجه',
                text: message,
                confirmButtonText: 'باشه',
                confirmButtonColor: '#ED6D37'
            });
        } else {
            alert(message);
        }
        return false;
    }

    if (property_type.val() == -1 || property_type.find("option:selected").text() == "") {
        return showFieldError(property_type, 'لطفاً نوع ملک را انتخاب کنید.');
    }
    if (structure_materials.val() == -1 || structure_materials.val() == null || structure_materials.find("option:selected").text() == "") {
        return showFieldError(structure_materials, 'لطفاً نوع سازه را انتخاب کنید.');
    }
    if (building_cost.val() == -1 || building_cost.val() == null || building_cost.val() == 'null' || building_cost.find("option:selected").text() == "") {
        return showFieldError(building_cost, 'لطفاً هزینه بازسازی هر متر مربع را انتخاب کنید.');
    }

    if (area_size.val() == '' && complex_area_size.val() == '') {
        return showFieldError(area_size.length ? area_size : complex_area_size, 'لطفاً متراژ مورد بیمه را وارد کنید.');
    }
    if (fire_province_select.val() == -1 || fire_province_select.val() == 'NAN' || fire_province_select.find("option:selected").text() == "") {
        return showFieldError(fire_province_select, 'لطفاً استان را انتخاب کنید.');
    }
    if (fire_city_select.val() == 'NAN' || fire_city_select.find("option:selected").text() == "") {
        return showFieldError(fire_city_select, 'لطفاً شهر را انتخاب کنید.');
    }
    if (fire_build_year_input.val() == 'NAN') {
        return showFieldError(fire_build_year_input, 'لطفاً سال ساخت ساختمان را انتخاب کنید.');
    }
    var url_param = '';
    var propertytype = property_type.val();
    var structureType = structure_materials.val();
    var use2800 = use_2800.length ? use_2800.is(':checked') : false;
    var buildingcost = building_cost.val();
    var appliancePrice = furniture_price.val();
    var complexappliancePrice = complex_furniture_price.val();
    var areasize = area_size.val();
    var complexareasize = complex_area_size.val();
    var unitcount = unit_count.val();
    var buildyear = fire_build_year_input.val();
    var provinceselect = fire_province_select.val();
    var cityselect = fire_city_select.val();

    if(isTejaratno){
        if (areasize && areasize != '') {
            var onebuldingCost = building_cost.find("option:selected").data('value');
            var buildCost = onebuldingCost  * 1000000 * areasize;
        }
        else{
            var onebuldingCost = building_cost.find("option:selected").data('value');
            var buildCost = onebuldingCost  * 1000000 * complexareasize;
        }


    }

    url_param += '?propertyType=' + propertytype;
    url_param += '&structureType=' + structureType;
    if(use2800){
        url_param += '&use2800=' + use2800;
    }
    url_param += '&buildingCost=' + buildingcost;

    if (appliancePrice && appliancePrice != '') {
        url_param += '&appliancePrice=' + appliancePrice;
    }
    else if(complexappliancePrice && complexappliancePrice != ''){
        url_param += '&appliancePrice=' + complexappliancePrice;
    }else{
        url_param += '&appliancePrice=0';
    }

    if (areasize && areasize != '') {
        url_param += '&areaSize=' + areasize;
    }
    else{
        url_param += '&areaSize=' + complexareasize;
    }

    if (unitcount && unitcount != '') {
        url_param += '&unitCount=' + unitcount;
    }

    if (buildyear && buildyear != '') {
        url_param += '&buildYear=' + buildyear;
    }

    if (provinceselect && provinceselect != '') {
        url_param += '&province=' + provinceselect;
    }

    if (cityselect && cityselect != '') {
        url_param += '&city=' + cityselect;
    }

    window.location = fireInsuranceSearchUrl + '/' + url_param;
}
$(document).ready(function () {

    $('.fire_insurance_searchBtn_top').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var property_type = $('#fire_property_type_select');
        var structure_materials = $('#fire_structure_materials_select');
        var use_2800 = $('#fire_use_2800_select');
        var building_cost = $('#fire_building_cost_select');
        var furniture_price = $('#fire_furniture_price_input');
        var complex_furniture_price = $('#fire_complex_furniture_price_input');
        var unit_count = $('#fire_unit_count_input');
        var area_size = $('#fire_insurance_area_size_input');
        var complex_area_size = $('#fire_complex_area_size_input');
        var fire_build_year_input = $('#fire_build_year_select');
        var fire_province_select = $('#fire_province_select');
        var fire_city_select = $('#fire_city_select');

        fireInsuranceSearch(property_type, structure_materials, use_2800, building_cost, furniture_price, complex_furniture_price, unit_count, area_size, complex_area_size, fire_build_year_input,fire_province_select,fire_city_select);
        return false;
    });

    $("#fire_property_type_select").change(function () {
        if ($(this).val() == 157 || $(this).val() == 158) {
            $(".furniture_price").show();
            $(".furniture_price").addClass('active');
            $(".insurance_area_size").show();
            $(".insurance_area_size").addClass('active');
            $(".unit_count").hide();
            $(".unit_count").removeClass('active');
            $(".complex_area_size").hide();
            $(".complex_area_size").removeClass('active');
            $(".complex_furniture_price").hide();
            $(".complex_furniture_price").removeClass('active')

        } else if ($(this).val() == 159) {
            $(".furniture_price").hide();
            $(".furniture_price").removeClass('active');
            $(".insurance_area_size").hide();
            $(".insurance_area_size").removeClass('active');
            $(".unit_count").show();
            $(".unit_count").addClass('active');
            $(".complex_area_size").show();
            $(".complex_area_size").addClass('active');
            $(".complex_furniture_price").show();
            $(".complex_furniture_price").addClass('active')
        }
    });
})

$.fn.extend(
    {
        animateCss: function (animationName) {
            var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            this.addClass('animated ' + animationName).one(
                animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                }
            );
        }
    }
);

